import { usePermissions, UserPermission, WriteOn } from 'modules/permissions';
import {
   StyledMessagedButton,
   StyledMessagePage,
   StyledMessagePageContainer,
   StyledMessagePageLogo,
   StyledMessagePageLogoContainer,
   StyledMessagePageText,
   StyledMessagePageTextContainer
} from 'shared/styled/message-page.styled';
import Button from 'components/controls/Button';
import { useHistory } from 'react-router-dom';
import { ConditionalRender } from 'components/layout/ConditionalRender';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import IconButton from '../../controls/Button/components/IconButton';

export const ObservationSafetyCheckHome = () => {
   const { t } = useTranslation();
   const history = useHistory();
   const { hasPermission } = usePermissions();

   const hasAccess = () => {
      return hasPermission(WriteOn(UserPermission.NewObservation));
   };

   function handleNearMissClick() {
      history.push('/nearmiss/new');
   }

   function handleGoodPracticeClick() {
      history.push('/goodpractice/new');
   }

   function handleIssueClick() {
      history.push('/issue/new');
   }

   function handleOpportunityClick() {
      history.push('/opportunity/new');
   }

   return (
      <StyledMessagePageContainer>
         <StyledMessagePage>
            <StyledMessagePageLogoContainer>
               <StyledMessagePageLogo />
            </StyledMessagePageLogoContainer>
            <StyledMessagePageTextContainer>
               <StyledMessagePageText>{t('OverviewPage.Observations')}</StyledMessagePageText>
               <StyledMessagePageText>{t('OverviewPage.EnsureSafeBeforeProceeding')}</StyledMessagePageText>
               <StyledMessagePageText>
                  <ConditionalRender condition={hasAccess}>
                     <StyledMessagedButton>
                        <Button text={t('OverviewPage.NearMiss')} onClick={handleNearMissClick} />
                        <ConditionalRender condition={i18next.language === 'gb'}>
                           <IconButton
                              iconName={'Info'}
                              title={
                                 'Where an unsafe action or situation is observed having the potential to cause injury, harm or damage.'
                              }
                           />
                        </ConditionalRender>
                     </StyledMessagedButton>
                     <StyledMessagedButton>
                        <Button text={t('OverviewPage.GoodPractice')} onClick={handleGoodPracticeClick} />
                        <ConditionalRender condition={i18next.language === 'gb'}>
                           <IconButton
                              iconName={'Info'}
                              title={
                                 'Where a positive action or situation is observed and can be shared to benefit the business or commend individuals who are seen to be working safely.'
                              }
                           />
                        </ConditionalRender>
                     </StyledMessagedButton>
                     <ConditionalRender condition={i18next.language === 'gb'}>
                        <StyledMessagedButton>
                           <Button text={t('OverviewPage.Issue')} onClick={handleIssueClick} />
                           <IconButton
                              iconName={'Info'}
                              title={'A problem that needs to be solved that can improve performance.'}
                              style={{ fontSize: '25px', margin: '-5px 0px' }}
                           />
                        </StyledMessagedButton>
                     </ConditionalRender>
                     <ConditionalRender condition={i18next.language === 'gb'}>
                        <StyledMessagedButton>
                           <Button text={t('OverviewPage.Opportunity')} onClick={handleOpportunityClick} />
                           {i18next.language === 'gb' && (
                              <IconButton
                                 iconName={'Info'}
                                 title={'An action that can be taken to improve performance.'}
                                 style={{ fontSize: '25px', margin: '-5px 0px' }}
                              />
                           )}
                        </StyledMessagedButton>
                     </ConditionalRender>
                  </ConditionalRender>
               </StyledMessagePageText>
            </StyledMessagePageTextContainer>
         </StyledMessagePage>
      </StyledMessagePageContainer>
   );
};
